import React from 'react';
import {useTranslation} from "react-i18next";

import Modal from "@components/modal/modal.component";
import {StyledModalContent} from "@components/modal/modal.style";
import {StyledButton} from "@components/button/button.style";

import {MissingReportNotice} from "@models/travelAllowance/ride";

type MissingReportNoticeModalProps = {
    notice?: MissingReportNotice;
    onClose: () => void;
    onDismissed: () => void;
}

const MissingReportNoticeModal: React.FC<MissingReportNoticeModalProps> = ({notice, onClose, onDismissed}: MissingReportNoticeModalProps) => {
    const {t} = useTranslation();

    return (
        <Modal
            isOpen={!!notice}
            disableClose={true}
            backdropDismiss={false}
            onDidDismiss={() => onDismissed()}
        >
            {
                notice &&
                <StyledModalContent className="t-p-25">
                    <h1 className="title center">{t("travelAllowance.ride.missingReportNotice.title")}</h1>
                    <div className="content">
                        {t("travelAllowance.ride.missingReportNotice.message", {date: notice.rideDate})}
                    </div>
                    <StyledButton className="footer" onClick={() => onClose()}>
                        {t("travelAllowance.ride.missingReportNotice.close")}
                    </StyledButton>
                </StyledModalContent>
            }
        </Modal>
    );
};

export default MissingReportNoticeModal;
